<nav class="subnav">
  <ul class="nav">
    <li class="nav-item" *ngIf="jobId === 0">
      <a class="nav-link active" [routerLink]="['/project/details/', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">Zum Projekt</a>
    </li>
    <li class="nav-item" *ngIf="jobId !== 0">
      <a class="nav-link active" [routerLink]="['/job/details/', projectId, jobId]">Zum Job</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!deliveries">
  <h2>Lieferschein {{ projectId }}.0004.{{ deliveryId }}</h2>
  <p *ngIf="!loading1">
    <span class="label label-light-blue">Lieferschein vom: {{ deliveries[0].delivery_date | date:'dd.MM.yyyy'  }}</span>
    <span class="label {{ statusLabel }}">Status: {{ statusText }}
    </span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row" *ngIf="!loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div class="card">
        <div class="card-header">
          {{ deliveries[0].name_project }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Kunde
                    </div>
                    <div class="clr-col-8">
                      {{ deliveries[0].company_name }}<br /><span *ngIf="deliveries[0].department">{{ deliveries[0].department }} <br /></span> {{ deliveries[0].street }}<br />{{ deliveries[0].postcode }} {{ deliveries[0].city }}
                      <span *ngIf="deliveries[0].country !== 'Deutschland'">{{ deliveries[0].country }}</span>
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/contact/details', splitProjectNumber(deliveries[0].project_id, 0) ]"></cds-icon>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/delivery/update', projectId, jobId, deliveryId]" [disabled]="disableDeliveryButton">Lieferschein bearbeiten</button>
                    <button class="btn btn-warning" (click)="deleteDelivery(projectId, deliveryId, jobId, statusText)" [disabled]="disableInvoiceButton">Lieferschein löschen</button>

                    <button class="btn" *ngIf="useRemarks" (click)="setRemarks(false)"><cds-icon shape="file"></cds-icon> Disable Remarks in PDF</button>
                    <button class="btn" *ngIf="!useRemarks" (click)="setRemarks(true)"><cds-icon shape="eye-hide"></cds-icon> Enable Remarks in PDF</button>
                  </div>

                  <ng-container *ngIf="!!positions">
                    <clr-datagrid *ngIf="editPos < 2" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                      <clr-dg-action-bar *ngIf="((editPos < 2) && (statusText === 'Offen'))">
                        <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Postionen löschen</button>
                        </div>
                      </clr-dg-action-bar>
                      <clr-dg-column [clrDgField]="'project_id'">Position</clr-dg-column>
                      <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                      <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                      <clr-dg-column>Material</clr-dg-column>
                      <clr-dg-column>Kennzeichnung</clr-dg-column>
                      <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
                      <clr-dg-column>Bemerkungen</clr-dg-column>
                      <clr-dg-column>Anzahl</clr-dg-column>
                      <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>
                      <clr-dg-placeholder>We couldn't find any Position for Delivery Note {{ projectId }}.{{ deliveryId }}!</clr-dg-placeholder>
                      <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                        <clr-dg-cell>{{ position.position }}<span *ngIf="position.part != null && position.part > 0">.{{ position.part }}</span> </clr-dg-cell>
                        <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                          <b>{{ position.name }}</b>
                          <clr-tooltip *ngIf="position.comment_phm">
                            <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                            <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                              <span>{{ position.comment_phm }}</span>
                            </clr-tooltip-content>
                          </clr-tooltip>
                          <span *ngIf="position.description"><br />{{ position.description }}</span>
                          <span *ngIf="position.taric && position.taric !== '0'"><br />(Zolltarifnummer: {{ position.taric }})</span>
                        </clr-dg-cell>
                        <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">{{ position.technical_drawing }}</clr-dg-cell>
                        <clr-dg-cell>{{ position.material }}
                          <span class="small" *ngIf="position.heat_nr !== 'null'"><br /><br />{{ position.heat_nr }}</span>
                          <span class="small" *ngIf="position.controlling_nr !== 'null'"><br *ngIf="((!position.heat_nr) || (position.heat_nr === 'null') || (position.heat_nr === ''))" /><br />{{ position.controlling_nr }}</span>
                        </clr-dg-cell>
                        <clr-dg-cell>{{ position.serial_nr }}</clr-dg-cell>
                        <clr-dg-cell>
                          <span *ngIf="position.specification">{{ position.specification }}</span>
                        </clr-dg-cell>
                        <clr-dg-cell>
                          <span *ngIf="position.remarks"><b>Leistungsumfang:</b> {{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                          <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                        </clr-dg-cell>
                        <clr-dg-cell class="center"><span *ngIf="position.number_of_pieces != null && position.number_of_pieces > 0">{{ position.number_of_pieces }}</span> </clr-dg-cell>
                        <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                          <button class="btn btn-sm" (click)="updatePositionMode(i, position.position ?? 0, position.part ?? 0)">
                            <cds-icon shape="pencil"></cds-icon>
                            <span class="clr-icon-title">Ändern</span>
                          </button>
                        </clr-dg-cell>
                      </clr-dg-row>
                      <clr-dg-footer>
                        <clr-dg-pagination #pagination [clrDgPageSize]="50">
                          <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                          von {{positions.length}} Position(en)
                        </clr-dg-pagination>
                      </clr-dg-footer>
                    </clr-datagrid>
                  </ng-container>

                  <app-delivery-details-edit-position [projectId]="projectId" [deliveryId]="deliveryId" [jobId]="jobId" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2" (updatedPosition)="updateDelivery($event)"></app-delivery-details-edit-position>

                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="basic = true; createDeliveryNote(positions)">PDF anzeigen</button>
                    <button *ngIf="(deliveries[0].status === 'open') && (editPos === 0)" class="btn" (click)="editPos = 1;" [disabled]="disableEditButton">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                    <button *ngIf="editPos === 0" class="btn btn-success" (click)="bookDelivery(projectId, deliveryId, 2)" [disabled]="disableDeliveryButton">Lieferschein buchen</button>
                    <button *ngIf="editPos === 0" class="btn btn-warning" (click)="changeDeliveryStatus(projectId, deliveryId, 1)" [disabled]="disableNoInvoiceButton">Lieferschein ohne Rechnung</button>
                  </div>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-delivery-details-documents [projectId]="projectId" [jobId]="jobId" [deliveryId]="deliveryId"></app-delivery-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ deliveries[0].employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">Lieferschein {{ projectId }}.0004.{{ deliveryId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>


<pre *ngIf="devMode" class="datepicker-output">
    {{ projectId | json }}
</pre>

<pre *ngIf="devMode" class="datepicker-output">
    {{ deliveries | json }}
</pre>
